import Color, { hsl } from "color";

const DEFAULT_TEXT_COLOR = Color("white");
export const LOW_CONTRAST_RATIO = 2;

/** White on dark backgrounds, a dark grey of the same hue on light ones. */
export function avatarTextColor(
  colorScheme: string | null | undefined,
): string {
  if (!colorScheme) return "white";

  return Color(colorScheme).contrast(DEFAULT_TEXT_COLOR) > LOW_CONTRAST_RATIO
    ? "white"
    : hsl(Color(colorScheme).hue(), 0, 15).hex();
}
